import React from "react"
import MapVisualInput from "./MapVisualInput"
import MapInfo from "./MapInfo"

function Map(props) {
    return (
        <div>
            <h1>Locate Tara's Hideouts</h1>
            <h3>Tara has hidden the Paradox Diamond somewhere in New York and time is running out to find it. We know Tara has three hideouts in the city but we don't know where.</h3>
            <MapVisualInput callBackOverlay={props.callBackOverlay} callBackStatus={props.callBackStatus} callBackRevealClues={props.callBackRevealClues}/>
            <br /> <br />
            <MapInfo />
        </div>
    )
}

export default Map